import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'

// import styles
import './movemodal.scss'

// Actions
import { moveOrder, getStepsBehind, getStepsAhead, getSteps } from '../../../actions/orders'

// import components
import Modal from '../../components/Modal'

// import utils
import { hasSubscriptionPermission } from '../../../utils/auth'
import { translation, enumtranslate } from '../../../utils/helpers'

// Elements
import Radio from '../../elements/radio'
import Button from '../../elements/button'
import Divider from '../../elements/divider'
import Grid from '../../elements/grid'
import Textarea from '../../elements/textarea'

import { ModalIcons } from '../../elements/icons'

class MoveModal extends Component {

  constructor (props) {
    super(props)
    this.state = {
      overflowHidden: false,
      clickOutsideClose: true,
      Step: 0,
      availableSteps: [],
      actionType: 0,
      comment: ''
    }
    this.modalTitle = this.modalTitle.bind(this)
    this.onClose = this.onClose.bind(this)
    this.moveOrder = this.moveOrder.bind(this)
    this.onInputChange = this.onInputChange.bind(this)
    this.renderAvailableSteps = this.renderAvailableSteps.bind(this)
    this.renderDeviation = this.renderDeviation.bind(this)
    this.renderPaintButtons = this.renderPaintButtons.bind(this)
    this.renderOther = this.renderOther.bind(this)
  }

  componentDidMount () {
    let step = (this.props.item.NewStepId) ? this.props.item.NewStepId : this.props.item.StepId
    let actionType = this.props.auth.departmentType === 1 ? 2 : 0
    this.setState({
      Step: step,
      actionType: actionType
    })
    if (this.props.type !== undefined) {
      if (this.props.type === 1) {
        this.props.getStepsBehind(this.props.item.Id).then((res) => {
          let newStep = res.data.filter(x => x.Step === step)[0]
          if (newStep === undefined) newStep = res.data[res.data.length - 1]
          this.setState({
            Step: newStep.Step,
            availableSteps: res.data
          })
        })
      } else {
        this.props.getStepsAhead(this.props.item.Id).then((res) => {
          let newStep = res.data.filter(x => x.Step === step)[0]
          if (newStep === undefined) newStep = res.data[0]
          this.setState({
            Step: newStep.Step,
            availableSteps: res.data
          })
        })
      }
    } else {
      // Get available steps for this order.
      this.props.getSteps(this.props.item.Id).then((res) => {
        // Determine if new step is ahead or behind current step.
        let newStepIndex = res.data.findIndex(s => s.Step === step)
        let currentStepIndex = res.data.findIndex(s => s.Step === this.props.item.StepId)
        if (res.data[newStepIndex].Order < res.data[currentStepIndex].Order) {
          this.props.getStepsBehind(this.props.item.Id).then((res) => {
            this.setState({ availableSteps: res.data })
          })
        } else {
          this.props.getStepsAhead(this.props.item.Id).then((res) => {
            this.setState({ availableSteps: res.data })
          })
        }
      })
    }
  }

  onClose () {
    this.props.onClose()
  }

  moveOrder (e) {
    e.preventDefault()
    // console.log('modal', this.props.item.StepId, this.state.Step)
    if (this.state.Step === 0) {
      // Toastr
      window.toastr.error(translation('13430'), translation('216'))
    } else {
      let moveData = {
        OrderIds: [this.props.item.Id],
        UserId: 0,
        StepFrom: this.props.item.StepId,
        StepTo: this.state.Step,
        Comment: this.state.comment,
        FilterSettings: {}
      }

      // console.log('Move data', moveData, this.props.item)
      this.props.onMoveOrders(moveData)
      this.onClose()
    }
  }

  onInputChange (e) {
    this.setState({
      [e.target.name]: parseInt(e.target.value)
    })
  }

  renderAvailableSteps () {
    let steps = []
    steps = this.state.availableSteps.map(x => x.Step)
    return (
      <div className='clearfix radio--inputs'>
        {steps.map((val, key) => {
          if (val === 0) return null // draft
          if (val === 8) return null // completed
          let name = enumtranslate('PaintShopOrderSteps', val)
          // console.log('step', val, name)
          return (
            <Radio key={key} id={'step-' + val} name='Step' value={val} onChange={this.onInputChange} checked={this.state.Step === val} labelText={translation(name)} />
          )
        })}
      </div>
    )
  }

  renderDeviation () {
    if (this.props.type !== 1 || !hasSubscriptionPermission(this.props.auth, 30, 20) || this.props.item.OrderType === 4 || this.props.show !== true || this.props.auth.departmentType === 1) return null
    // console.log('rendered anyway')
    const GoToDeviation = (id, e) => {
      e.preventDefault()
      this.onClose()
      // console.log('Move with deviation', this.state.Step)
      this.props.router.push({
        pathname: '/pricecalculation/' + this.props.item.Id + '/' + id,
        state: {
          stepId: this.state.Step
        }
      })
      // this.props.router.push('/pricecalculation/' + this.props.item.Id + '/' + id)
    }
    return (
      <Grid>
        <Button style='link' onClick={GoToDeviation.bind(this, 5)} labelText={translation('310')} />
        <Button style='link' onClick={GoToDeviation.bind(this, 6)} labelText={translation('311')} />
      </Grid>
    )
  }

  renderOther () {
    const onChange = (e) => {
      this.setState({
        comment: e.target.value
      })
    }
    return (
      <Grid cols='1fr'>
        <Textarea labelText={15197} onChange={onChange} />
        <Button labelText={this.props.type === 1 ? translation('13481') : translation('13479')} onClick={this.moveOrder} />
      </Grid>
    )
  }

  renderPaintButtons () {
    const setActionType = (type) => {
      this.setState({
        actionType: type
      })
    }
    return (
      <Grid>
        <Button labelText={16661} onClick={setActionType.bind(this, 1)} />
        <Button style='link' labelText={227} onClick={setActionType.bind(this, 2)} />
      </Grid>
    )
  }

  renderViewBackward () {
    let actionType = this.state.actionType
    return (
      <div>
        {this.renderAvailableSteps()}
        <Divider size={3} noLine />
        {actionType === 0 && this.renderPaintButtons()}
        {actionType === 1 && this.renderDeviation()}
        {actionType === 2 && this.renderOther()}
      </div>
    )
  }

  renderViewForward () {
    return (
      <div>
        {this.renderAvailableSteps()}
        <Divider size={3} noLine />
        <Button labelText={this.props.type === 1 ? translation('13481') : translation('13479')} onClick={this.moveOrder} />
      </div>
    )
  }

  modalTitle () {
    let { item } = this.props
    let title = ''

    // Model
    if (item.Model) {
      title += item.Model
    }

    // RegNumber
    if (item.RegNumber) {
      if (item.Model) {
        title += ', '
      }
      title += item.RegNumber
    }

    // Title empty
    if (title === '') {
      title += item.Id
    }

    return title
  }

  render () {
    let icon = (this.props.type === 2) ? ModalIcons.Forward : ModalIcons.Backward
    return (
      <div className='move__modal'>
        <Modal {...this.props}
          header={this.modalTitle()}
          overflowHidden={this.state.overflowHidden}
          clickOutsideClose={this.state.clickOutsideClose}
          onClose={this.onClose}
          icon={icon}>
          {this.props.type === 1 ? this.renderViewBackward() : this.renderViewForward()}
        </Modal>
      </div>
    )
  }

}

MoveModal.propTypes = {
  auth: PropTypes.object.isRequired
}

function mapStateToProps (state) {
  return {
    auth: state.auth
  }
}

export default connect(mapStateToProps, {
  moveOrder,
  getStepsBehind,
  getStepsAhead,
  getSteps
})(MoveModal)



// WEBPACK FOOTER //
// ./src/app/shared/modals/MoveModal/index.js